import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';

import { Text } from '@/components/typography';
import type SolAPIError from '@/error/SolAPIError';

type Props = {
  reportName?: string;
  isLoading: boolean;
  error?: SolAPIError | null;
};

const ReportName = ({ reportName, isLoading, error }: Props) => {
  if (!isLoading && !reportName && !error) {
    return null;
  }

  if (error) {
    return (
      <div className="mb-6 flex gap-2">
        <Text variant="body1" color="red">
          {error?.getFirstError ? error.getFirstError().message : t`Error loading report.`}
        </Text>
      </div>
    );
  }

  return (
    <div className="mb-6 flex gap-2">
      <Text className="whitespace-nowrap" variant="body1" color="grey">
        <Trans>Report Name:</Trans>
      </Text>
      {reportName ? (
        <Text variant="body1" color="grey">
          {reportName}
        </Text>
      ) : (
        <Text variant="body1" color="grey" italic>
          <Trans>Loading...</Trans>
        </Text>
      )}
    </div>
  );
};

export default ReportName;
